import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { RdsChipsModule } from '../chips/index';
import { RdsDateFiltersToChipsPipe } from './date-filter-chips.pipe';
import { RdsDateFilterComponent } from './date-filter.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatIconModule,
    MatInputModule,
    MatMomentDateModule,
    MatSelectModule,
    RdsChipsModule,
  ],
  exports: [RdsDateFilterComponent],
  declarations: [RdsDateFilterComponent, RdsDateFiltersToChipsPipe],
})
export class RdsDateFilterModule {}

export * from './date-filter.component';
